module.exports = __webpack_public_path__ + "img/european.award.134d1840.png";